import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Select2Data } from 'ng-select2-component';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { LeaveService } from 'src/app/providers/leave/leave.service';
declare let $: any;
interface lvRulesLimit {
  can_apply: boolean;
  limit: null | number;
  dates_control: boolean;
  helptext: string;
  applied?: number;
  pending?: number;
}

@Component({
  selector: 'app-apply-leave',
  templateUrl: './apply-leave.component.html',
  styleUrls: ['./apply-leave.component.scss'],
})
export class ApplyLeaveComponent implements OnInit, OnDestroy {
  @Input()
  modalCall: Subject<any>;
  docType = false;
  behalf = '0';
  isBehalf = false;
  submitted = false;
  applyLeaveForm: FormGroup;
  isManager = false;
  actualManager = false;
  response: any;
  docCertificate: any = [];
  relateWith: any = 0;
  today: any;
  CurDate: any;
  maxToDate: any;
  searchFromDate: any = new Date();
  searchToDate: any = new Date();
  lveType: Select2Data = [
    { label: 'Select Leave Type', value: '', disabled: true },
  ];
  onBehalfEmp: Select2Data = [
    { label: 'Select Employee', value: '', disabled: true },
  ];
  get empLeaveError(): any {
    return this.applyLeaveForm.controls;
  }
  get from_date(): any {
    return this.applyLeaveForm.get('from_date').value;
  }
  get lv_type(): any {
    return this.applyLeaveForm.get('lv_type').value;
  }
  get no_of_days(): any {
    return this.applyLeaveForm.get('no_of_days').value;
  }

  lvRules: lvRulesLimit = {
    dates_control: false,
    limit: null,
    can_apply: true,
    helptext: '',
    applied: 0,
    pending: 0,
  };
  constructor(
    private formBuilder: FormBuilder,
    private notifyService: NotificationService,
    private dashService: DashboardService,
    private levService: LeaveService
  ) {
    this.maxToDate = moment(new Date()).endOf('year').format('YYYY-MM-DD');
    // console.log('call constructor');
    // this.today = moment().format('YYYY-MM-DD');
    // this.CurDate = moment().startOf('month').format('YYYY-MM-DD');
    console.log(moment().clone().startOf('month').format('YYYY-MM-DD'));
    this.CurDate = moment().subtract(2, 'months').format('YYYY-MM-DD');
    console.log(this.CurDate);
    const frstDay = moment(this.CurDate)
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD');
    console.log(frstDay);
    const frmDate = moment(frstDay).add(24, 'days').format('YYYY-MM-DD');
    console.log(frmDate);
    this.CurDate = frmDate;

    this.searchToDate = moment().clone().endOf('month').format('YYYY-MM-DD');
    this.searchFromDate = moment()
      .clone()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD');
  }

  ngOnInit(): void {
    this.masterUserGet();
    this.modalCall.subscribe((event) => {
      this.behalf = '0';
      this.getleaveType();
      this.lvRules = {
        dates_control: false,
        limit: null,
        can_apply: true,
        helptext: '',
        applied: 0,
        pending: 0,
      };
      $('#add_employee_leave').modal({ backdrop: 'static', keyboard: false });
    });
    console.log('call on init');
    this.employeeFormFields();
    this.applyLeaveForm.patchValue({
      is_on_behalf: '0',
    });
  }

  getleaveType(userid = ''): void {
    this.dashService.getLeaveType(userid).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.lveType = this.response.data;
        } else {
          this.notifyService.showInfo(this.response.msg, 'Info!');
        }
      },
      (err) => {
        this.notifyService.showInfo('Data Not Found!', 'Info!');
      }
    );
  }

  employeeFormFields(): void {
    this.applyLeaveForm = this.formBuilder.group({
      lv_type: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      no_of_days: ['', Validators.required],
      reason: ['', Validators.required],
      is_on_behalf: [''],
      on_behalf_created_by: [''],
      doc_attachment: [''],
      fhDay: ['1'],
    });
  }

  onCloseModal(): void {
    this.behalf = '0';
    this.submitted = false;
    this.applyLeaveForm.reset();
  }

  onSubmitLeave(): void {
    this.submitted = true;
    if (this.applyLeaveForm.invalid) {
      return;
    }
    if (this.applyLeaveForm.get('fhDay').value === '') {
      alert('Please select day type ( Half / Full Day)');
      return;
    } else {
      console.log(this.applyLeaveForm.get('is_on_behalf').value);
      if (this.applyLeaveForm.get('is_on_behalf').value === '0') {
        this.isManager = false;
      } else {
        this.isManager = this.actualManager;
      }

      const isManage = this.isManager ? '1' : '0';
      const addLeave = new FormData();
      const fhDays =
        this.applyLeaveForm.get('no_of_days').value > 1
          ? 1
          : this.applyLeaveForm.get('fhDay').value;
      addLeave.append('lv_type', this.applyLeaveForm.get('lv_type').value);
      addLeave.append('from_date', this.applyLeaveForm.get('from_date').value);
      addLeave.append('to_date', this.applyLeaveForm.get('to_date').value);
      addLeave.append(
        'no_of_days',
        this.applyLeaveForm.get('no_of_days').value
      );
      addLeave.append('reason', this.applyLeaveForm.get('reason').value);
      addLeave.append(
        'is_on_behalf',
        this.applyLeaveForm.get('is_on_behalf').value
      );
      addLeave.append(
        'on_behalf_created_by',
        this.applyLeaveForm.get('on_behalf_created_by').value
      );
      addLeave.append('doc_attachment', this.docCertificate);
      addLeave.append('is_manager', isManage);
      addLeave.append('fhDay', fhDays);
      addLeave.append('relateWith', this.relateWith);
      addLeave.append('source', 'PORTAL');
      addLeave.append('remark', 'Apply from portal');
      this.dashService.addleave(addLeave).subscribe(
        (res) => {
          this.isManager = this.actualManager;
          console.log(res);
          this.response = res;
          this.submitted = false;
          if (this.response.status) {
            this.notifyService.showSuccess(this.response.msg, 'Success!');
            $('#add_employee_leave').modal('hide');
            // this.leavesGet(this.searchFromDate, this.searchToDate);
            this.onCloseModal();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            this.notifyService.showError(this.response.msg, 'Info!');
          }
        },
        (err) => {
          this.submitted = false;
        }
      );
    }
  }

  chosenType(event): void {
    this.lvRules.can_apply = true;
    this.lvRules.dates_control = false;
    this.lvRules.limit = null;
    if (event.value) {
      this.applyLeaveForm.get('from_date').reset();
      this.applyLeaveForm.get('to_date').reset();
      this.applyLeaveForm.get('no_of_days').reset();
      this.applyLeaveForm.get('reason').reset();
      if (event.value === 3) {
        this.docType = true;
      } else {
        this.docType = false;
      }

      if (event.value === 6) {
        this.maxToDate = moment(new Date()).add(1, 'year').format('YYYY-MM-DD');
        console.log(this.maxToDate);
      } else {
        this.maxToDate = moment(new Date()).endOf('year').format('YYYY-MM-DD');
      }

      if (event.value == 7) {
        // WFH

        if (this.applyLeaveForm.get('is_on_behalf').value === '0') {
          this.isManager = false;
        } else {
          this.isManager = this.actualManager;
        }

        const isManage = this.isManager ? '1' : '0';
        const addLeave = new FormData();
        addLeave.append('lv_type', this.applyLeaveForm.get('lv_type').value);
        addLeave.append(
          'is_on_behalf',
          this.applyLeaveForm.get('is_on_behalf').value
        );
        addLeave.append(
          'on_behalf_created_by',
          this.applyLeaveForm.get('on_behalf_created_by').value
        );
        addLeave.append('is_manager', isManage);
        this.levService.checkLeaveRulesLimit(addLeave).subscribe((res) => {
          this.lvRules.can_apply = res.can_apply;
          if (res.limit == 0) {
            this.lvRules.dates_control = false;
          } else if (res.limit == null) {
            this.lvRules.dates_control = false;
          } else {
            this.lvRules.dates_control = true;
          }
        });
      } //end of if
    }
  }

  getFromDate(): void {
    this.applyLeaveForm.get('to_date').reset();
    this.applyLeaveForm.get('no_of_days').reset();
    if (
      this.applyLeaveForm.get('lv_type').value === 21 ||
      this.applyLeaveForm.get('lv_type').value === 22 ||
      this.applyLeaveForm.get('lv_type').value === 31
    ) {
      this.lveType.forEach((el: any) => {
        if (el.value === this.applyLeaveForm.get('lv_type').value) {
          this.relateWith = el.relate_with;
          return false;
        }
      });
      console.log(this.applyLeaveForm.get('from_date').value);
      this.maxToDate = this.applyLeaveForm.get('from_date').value;
      this.applyLeaveForm.controls.to_date.setValue(this.maxToDate);
      this.getToDate();
      this.applyLeaveForm.patchValue({
        fhDay: '0.5',
      });
      this.applyLeaveForm.get('fhDay').disable();
    } else {
      console.log(this.maxToDate);
      if (this.applyLeaveForm.get('from_date').value > this.maxToDate) {
        this.applyLeaveForm.get('from_date').reset();
        this.notifyService.showError('Invalid Date', 'Info!');
      }
      this.relateWith = 0;
      // this.maxToDate = '';
      this.applyLeaveForm.get('fhDay').enable();
      this.applyLeaveForm.patchValue({
        fhDay: '1',
      });

      // if (this.lvRules.dates_control) {
      //   this.maxToDate = moment(this.applyLeaveForm.get('from_date').value)
      //     .add(this.lvRules.limit, 'days')
      //     .format('YYYY-MM-DD');
      //   console.log(this.maxToDate);
      // }
    }
  }

  getToDate(): void {
    this.docCertificate = [];
    this.applyLeaveForm.controls.fhDay.setValue(1);
    // tslint:disable-next-line: one-variable-per-declaration
    let a, b, c;
    a = moment(this.applyLeaveForm.value.from_date);
    b = moment(this.applyLeaveForm.value.to_date);
    c = b.diff(a, 'days');
    this.applyLeaveForm.get('no_of_days').setValue(c + 1);
    if (this.docType && c + 1 > 3) {
      this.applyLeaveForm
        .get('doc_attachment')
        .setValidators([Validators.required]);
      this.applyLeaveForm.get('doc_attachment').updateValueAndValidity();
    } else {
      this.applyLeaveForm.get('doc_attachment').clearValidators();
      this.applyLeaveForm.get('doc_attachment').updateValueAndValidity();
    }

    console.log(
      `${this.applyLeaveForm.get('lv_type').value} == ${
        this.lvRules.dates_control
      }`
    );
    if (
      this.applyLeaveForm.get('lv_type').value == 7 &&
      this.lvRules.dates_control
    ) {
      // if (this.applyLeaveForm.get('no_of_days').value > this.lvRules.limit) {
      //   this.notifyService.showInfo(
      //     'you can not apply WFH more than ' +
      //       this.lvRules.limit +
      //       ' days quota at a time',
      //     'Leave'
      //   );
      //   this.applyLeaveForm.controls.to_date.setValue('');
      //   return;
      // }

      if (this.applyLeaveForm.get('is_on_behalf').value === '0') {
        this.isManager = false;
      } else {
        this.isManager = this.actualManager;
      }

      const isManage = this.isManager ? '1' : '0';
      const addLeave = new FormData();
      addLeave.append('lv_type', this.applyLeaveForm.get('lv_type').value);
      addLeave.append('from_date', this.applyLeaveForm.get('from_date').value);
      addLeave.append('to_date', this.applyLeaveForm.get('to_date').value);
      addLeave.append(
        'no_of_days',
        this.applyLeaveForm.get('no_of_days').value
      );
      addLeave.append(
        'is_on_behalf',
        this.applyLeaveForm.get('is_on_behalf').value
      );
      addLeave.append(
        'on_behalf_created_by',
        this.applyLeaveForm.get('on_behalf_created_by').value
      );
      addLeave.append('is_manager', isManage);
      this.levService.checkLeaveRules(addLeave).subscribe((res) => {
        if (res.show_msg) {
          this.notifyService.showInfo(res.msg, 'Leave');
          this.applyLeaveForm.controls.to_date.setValue('');
          return;
        }
        if (
          res.applied + res.pending <= res.limit &&
          this.applyLeaveForm.get('no_of_days').value > res.limit &&
          res.limit > 0
        ) {
          this.notifyService.showInfo(
            'you can not apply WFH more than ' +
              res.limit +
              ' days quota at a time',
            'Leave'
          );
          this.applyLeaveForm.controls.to_date.setValue('');
          return;
        }
        if (res.applied > 0) {
          // if (res.pendingApproval > 0) {
          //   this.notifyService.showInfo(
          //     'Your WFH is pending for apprval and hence you cannot apply further WFH',
          //     'Leave'
          //   );
          //   return;
          // }

          if (
            this.applyLeaveForm.get('lv_type').value == 7 &&
            this.lvRules.dates_control &&
            this.applyLeaveForm.get('no_of_days').value > res.pending &&
            res.pending > 0
          ) {
            this.notifyService.showInfo(
              `You have ${res.pending} WFH in your weekly quota. Please consume your WFH quota for the week and then only you can apply for exceptional WFH`,
              'Leave'
            );
            this.applyLeaveForm.controls.to_date.setValue('');
            return;
          }

          this.notifyService.showInfo(res.msg);
          this.lvRules.helptext = res.helptext;
        } else {
          this.lvRules.helptext = '';
        }
      });
    } //end of else condition
  } //end of function

  ngOnDestroy(): void {
    // needed if child gets re-created (eg on some model changes)
    // note that subsequent subscriptions on the same subject will fail
    // so the parent has to re-create parentsSubject on changes
    this.modalCall.unsubscribe();
  }

  masterUserGet(): void {
    this.levService.getMyReporties().subscribe(
      (res) => {
        this.response = res;
        this.isManager = this.response.is_behalf_user;
        this.actualManager = this.response.is_behalf_user;

        if (this.response.status) {
          this.onBehalfEmp = this.response.data;
          // this.response.data.forEach(element => {
          //    this.onBehalfEmp.push({label: element.name, value: element.id});
          // });
        } else {
          // this.notifyService.showInfo(this.response.msg, 'Info!');
        }
      },
      (err) => {
        // this.notifyService.showInfo('Users Not Found!', 'Info!');
      }
    );
  }

  isOnBehalf(event): void {
    if (event.target.value === '1') {
      this.applyLeaveForm
        .get('on_behalf_created_by')
        .setValidators([Validators.required]);
      this.applyLeaveForm.get('on_behalf_created_by').updateValueAndValidity();
      this.lveType = [
        { label: 'Select Leave Type', value: '', disabled: true },
      ];
      this.isBehalf = true;
    } else {
      this.applyLeaveForm.get('on_behalf_created_by').clearValidators();
      this.applyLeaveForm.get('on_behalf_created_by').updateValueAndValidity();
      this.getleaveType();
      this.isBehalf = false;
    }
  }

  updateLeaveType(event): void {
    if (event.value) {
      this.getleaveType(event.value);
    } else {
      this.lveType = [
        { label: 'Select Leave Type', value: '', disabled: true },
      ];
    }
  } // end of function

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.docCertificate = file;
    }
  }
}
